import { removeDupes, cleanObject, isTempId } from 'utils/helpers';

const checklists = (state = {
    items: []
}, action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'TEAM_CHANGE':
        case 'RESET_STORE':
            return {
                items: []
            };

        case 'CHECKLIST_CREATE_REQUESTED':
        case 'CHECKLIST_ADD_SOCKET':
            return Object.assign({}, state, {
                items: removeDupes([...state.items, action.payload.checklist])
            });

        case 'CHECKLIST_CREATE_FAILED':
            return Object.assign({}, state, {
                items: state.items.filter(checklist => checklist !== action.payload.fragment)
            });

        case 'CHECKLIST_CREATE_SUCCEEDED':
            return Object.assign({}, state, {
                items: state.items
                    .filter(checklist => checklist.id !== action.payload.checklistId)
                    .map(checklist => {
                        if (checklist === action.payload.fragment) {
                            checklist.id = action.payload.checklistId;
                        }

                        return checklist;
                    })
            });

        case 'CHECKLIST_FETCH_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items.filter(checklist => checklist.id !== action.payload.checklistId), {
                    ...(state.items.find(checklist => checklist.id === action.payload.checklistId) || {}),
                    id: action.payload.checklistId,
                    loading: true
                }]
            });

        case 'CHECKLIST_FETCH_FAILED':
            return Object.assign({}, state, {
                items: [...state.items.filter(checklist => checklist.id !== action.payload.checklistId), {
                    id: action.payload.checklistId,
                    error: true
                }]
            });

        case 'CHECKLIST_FETCH_SUCCEEDED':
            if (!action.payload?.checklist?.id) {
                return state;
            }

            return Object.assign({}, state, {
                items: [...state.items.filter(checklist => checklist.id !== action.payload.checklist.id), action.payload.checklist]
            });

        case 'CHECKLIST_UPDATE_REQUESTED':
        case 'CHECKLIST_UPDATE_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(checklist => {
                    if (checklist.id === action.payload.checklistId) {
                        return Object.assign({}, checklist, cleanObject(action.payload.checklistProps || action.payload.checklist));
                    }

                    return checklist;
                })
            });

        case 'CHECKLIST_REMOVE_REQUESTED':
        case 'CHECKLIST_REMOVE_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(checklist => {
                    if (checklist.id === action.payload.checklistId) {
                        return {
                            id: checklist.id,
                            removed: true
                        };
                    }

                    return checklist;
                })
            });

        case 'CHECKLIST_ITEMS_CREATE_REQUESTED':
        case 'CHECKLIST_ITEMS_ADD_SOCKET':
            return Object.assign({}, state, {
                items: state.items.map(checklist => {
                    if (checklist.id !== action.payload.checklistId) {
                        return checklist;
                    }

                    return {
                        ...checklist,
                        items: removeDupes([...(checklist?.items || []), ...(action.payload.checklistItems || [])])
                    }
                })
            });

        case 'CHECKLIST_ITEMS_CREATE_FAILED':
            return Object.assign({}, state, {
                items: state.items.map(checklist => {
                    if (checklist.id !== action.payload.checklistId) {
                        return checklist;
                    }

                    return {
                        ...checklist,
                        items: checklist.items.filter(checklist => !isTempId(checklist.id))
                    }
                })
            });

        case 'CHECKLIST_ITEMS_CREATE_SUCCEEDED':
            return Object.assign({}, state, {
                items: state.items.map(checklist => {
                    if (checklist.id !== action.payload.checklistId) {
                        return checklist;
                    }

                    return {
                        ...checklist,
                        items: [...checklist.items
                            .filter(checklistItem => !action.payload.checklistItems.some(item => item.id === checklistItem.id) && !isTempId(checklistItem.id)),
                            ...action.payload.checklistItems
                        ]
                    }
                })
            });

        case 'CHECKLIST_ITEM_UPDATE_REQUESTED':
        case 'CHECKLIST_ITEM_UPDATE_SOCKET':
            return Object.assign({}, state, {
                items: state.items.map(checklist => {
                    if (checklist.id !== action.payload.checklistId) {
                        return checklist;
                    }

                    return {
                        ...checklist,
                        items: [...checklist.items].map(checklistItem => {
                            if (checklistItem.id === action.payload.checklistItemId) {
                                return Object.assign({}, checklistItem, cleanObject(action.payload.checklistItemProps || action.payload.checklistItem));
                            }
                            return checklistItem;
                        })
                    }
                })
            });

        case 'CHECKLIST_ITEM_REMOVE_REQUESTED':
        case 'CHECKLIST_ITEM_REMOVE_SOCKET':
            return Object.assign({}, state, {
                items: state.items.map(checklist => {
                    if (checklist.id !== action.payload.checklistId) {
                        return checklist;
                    }

                    return {
                        ...checklist,
                        items: checklist.items.filter(checklistItem => checklistItem.id !== action.payload.checklistItemId)
                    }
                })
            });

        default:
            return state;
    }
}

export default checklists;
